import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/hosting/bg.png'
import hosting from '../../assets/images/hosting/1.png'
import hosting2 from '../../assets/images/hosting/2.png'

import {TbExclamationCircle, FiArrowRightCircle, FiChevronRight, FiHelpCircle } from '../../assets/icons/vander'
import { hostingPrice, hostingServices } from '../../data/data'

export default function IndexHosting() {
  return (
    <>
    <Navbar navLight={true}/> 
    <section className="bg-half-260 bg-primary hosting-hero d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="container">
          <div className="row mt-5">
              <div className="col-12">
                  <div className="title-heading">
                      <h4 className="display-4 fw-bold text-white title-dark mb-3">Fast & Fully Safe <br/> Web Hosting</h4>
                      <p className="para-desc text-white-50">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="#" className="btn btn-light">Get Started</Link>
                          <p className="text-white-50 mb-0 mt-3"><TbExclamationCircle className="align-middle"/> No credit card required</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Web Hosting Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {hostingServices.map((item,index)=>{
              let Icon = item.icon
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="d-flex feature p-3 py-4 rounded">
                        <Icon className="text-primary h3 me-2"/>
                        <div className="flex-1 content d-block overflow-hidden">
                            <h4 className="title">Shared Hosting</h4>
                            <p className="text-muted mt-2">The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in.</p>
                            <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <img src={hosting} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Globally Server Access <br/> Across The World</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2">
                  <img src={hosting2} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Powerful and Secure <br/> Server From Any Treats</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-primary">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title text-white title-dark mb-4">Choose Awesome Plan For Your Needs</h4>
                      <p className="text-white-50 para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section pt-0 bg-light">
      <div className="container absolute-top">
          <div className="row">
            {hostingPrice.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="card card pricing-plan border-0 shadow rounded">
                          <div className="plans p-4 border-bottom">
                              <h2><Icon className={item.iconColor}/></h2>
                              <h4 className="title">{item.title}</h4>
                              <ul className="list-unstyled mt-3 mb-0 ps-0">
                                {item.feature.map((el,index)=>{
                                  return(
                                    <li className="text-muted mt-2" key={index}><FiArrowRightCircle  className="text-primary me-2"/><span className="fw-bold">{el.f1}</span> {el.f2}</li>
                                  )
                                })}
                              </ul>
                          </div>
                          <div className="rates p-3 px-4">
                              <Link to="#" className="text-dark">
                                  <h5 className="float-end icon mt-3"><FiChevronRight className="h2 mb-0 me-2"/></h5>
                                  <div className="d-flex">
                                      <span className="h5 mb-0 mt-2">$</span>
                                      <span className="price h1 mb-0">{item.Price}</span>
                                      <span className="h5 align-self-end mb-0">/mo</span>
                                  </div>
                              </Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container">
          <div className="row">
              <div className="col-md-6 col-12">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0">How our <span className="text-primary">Leaping</span> work ?</h5>
                          <p className="answer text-muted mb-0">Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> What is the main process open account ?</h5>
                          <p className="answer text-muted mb-0">If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 pt-2">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> How to make unlimited data entry ?</h5>
                          <p className="answer text-muted mb-0">Furthermore, it is advantageous when the dummy text is relatively realistic so that the layout impression of the final publication is not compromised.</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 pt-2">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> Is <span className="text-primary">Leaping</span> safer to use with my account ?</h5>
                          <p className="answer text-muted mb-0">The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language which more or less corresponds to 'proper' Latin.</p>
                      </div>
                  </div>
              </div>
          </div>

          <div className="row mt-md-5 mt-4 pt-lg-5 pt-4 justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Have Question ? Get in touch!</h4>
                      <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <Link to="/contact" className="btn btn-primary mt-4"><i className="mdi mdi-phone"></i> Contact us</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>
    
    <Footer/>
    </>
  )
}
